var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5512,
    cy: 11.5512,
    r: 11.5512,
    fill: "#C5C5C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.775 10.396H6.90447C6.2809 10.396 5.77539 10.9129 5.77539 11.5506V11.5516C5.77539 12.1893 6.2809 12.7062 6.90447 12.7062H16.775C17.3986 12.7062 17.9041 12.1893 17.9041 11.5516V11.5506C17.9041 10.9129 17.3986 10.396 16.775 10.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1287,
    height: 2.31023,
    fill: "white",
    transform: "translate(5.77539 10.396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.8f64f126c61c84d653a9223e1fea24b2.svg";
export { ForwardRef as ReactComponent };